import { useSquash } from '@src/hooks/useSquash';
import intro_1 from '../../public/assets/highRes/1_intro.png';
import happy_1 from '../../public/assets/highRes/1_happy.png';
import happy_2 from '../../public/assets/highRes/2_happy.png';
import happy_3 from '../../public/assets/highRes/3_happy.png';
import happy_4 from '../../public/assets/highRes/4_happy.png';
import happy_5 from '../../public/assets/highRes/5_happy.png';
import neutral_1 from '../../public/assets/highRes/1_neutral.png';
import neutral_2 from '../../public/assets/highRes/2_neutral.png';
import neutral_3 from '../../public/assets/highRes/3_neutral.png';
import neutral_4 from '../../public/assets/highRes/4_neutral.png';
import neutral_5 from '../../public/assets/highRes/5_neutral.png';
import sad_1 from '../../public/assets/highRes/1_sad.png';
import sad_2 from '../../public/assets/highRes/2_sad.png';
import sad_3 from '../../public/assets/highRes/3_sad.png';
import sad_4 from '../../public/assets/highRes/4_sad.png';
import sad_5 from '../../public/assets/highRes/5_sad.png';
import useWindowDimensions from '@src/hooks/useWindowDimensions';
import { SquashMood } from '@src/data/types';
import { useState, useEffect, useRef } from 'react';

type MoodImages = {
  [level in 0 | 1 | 2 | 3 | 4]: Record<SquashMood, string>;
};

const moodImages: MoodImages = {
  0: { happy: happy_1, thirsty: neutral_1, sad: sad_1 },
  1: { happy: happy_2, thirsty: neutral_2, sad: sad_2 },
  2: { happy: happy_3, thirsty: neutral_3, sad: sad_3 },
  3: { happy: happy_4, thirsty: neutral_4, sad: sad_4 },
  4: { happy: happy_5, thirsty: neutral_5, sad: sad_5 },
};

export const SquashHighRes = ({ isIntro }: { isIntro?: boolean }) => {
  const { activeSquash } = useSquash();
  const { height } = useWindowDimensions();
  const [isLevelingUp, setIsLevelingUp] = useState(false);

  const prevLevelRef = useRef(activeSquash?.onChainLevel ?? 0);

  useEffect(() => {
    const currentLevel = activeSquash?.onChainLevel ?? 0;

    // show animation if level increased
    if (currentLevel > prevLevelRef.current) {
      setIsLevelingUp(true);
      setTimeout(() => {
        setIsLevelingUp(false);
      }, 1000);
    }

    prevLevelRef.current = currentLevel;
  }, [activeSquash?.onChainLevel]);

  // If in intro mode, always show level 0 squash with happy mood
  if (isIntro) {
    return (
      <div
        className={`absolute inset-x-0 z-10 ${
          height < 750 ? 'bottom-[-10%]' : 'bottom-0'
        }`}
      >
        <div className='origin-[50%_75%] animate-breathe'>
          <img className='h-full w-full' src={intro_1} alt='Squash' />
        </div>
      </div>
    );
  }

  if (!activeSquash) {
    return null;
  }

  const level = Math.min(activeSquash.onChainLevel, 4);
  const image =
    moodImages[level as keyof MoodImages][activeSquash.mood as SquashMood];

  if (!image) {
    return null;
  }

  return (
    <div className='absolute inset-0 z-10 h-full w-full'>
      <div className='absolute inset-0 origin-bottom animate-breathe'>
        <img
          className={`h-full w-full object-cover
            ${isLevelingUp ? 'opacity-0' : 'opacity-100'}
            transition-opacity duration-1000`}
          src={image}
          alt='Squash'
        />
      </div>
      <div
        className={`absolute inset-0 bg-white transition-opacity duration-1000
          ${isLevelingUp ? 'opacity-100' : 'opacity-0'}`}
      />
    </div>
  );
};
